import {Link} from 'react-router-dom' ;
import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../../components/button/primary';
import CardNormal from '../../../components/cards/cardNormal';
import Input from '../../../components/input/input';
import Colors from '../../../utils/theme/colors';
import useApi from '../../../utils/helper/api';
import useValidation from '../../../utils/helper/validate';
import useAlert from '../../../utils/helper/toast'; 


function AdminPasswordRecoveryOTPView(){
let [busy, setBusy] = useState(false);
let [otp, setOtp] = useState({});

let api = useApi();
let validate = useValidation();
let alert = useAlert();
let navigate = useNavigate()


async function verify(){
   let err;
   if(!otp.v || otp.v.length < 6  ){
      otp.e=true; otp.m="Provide a valid OTP "; setOtp(JSON.parse(JSON.stringify(otp))); err=true;
   }
   else{ otp.e=false; err=false; setOtp(JSON.parse(JSON.stringify(otp))); }
    
   if(err){
      alert.toast("Fire", "success"); return;
   }
   alert.toast("Nice work!!! Go and reset password", "success");
   setBusy(true)
   navigate("/ad-management/auth/reset-password")
   //make network request here
}

return(
   <div className=' no-margin' style={{minHeight:"100vh"}}>

      <div style={{width:"100%", minHeight:"95vh", display:'flex', justifyContent:'center', alignItems:"center"}}>
         <div className='col-md-5 no-padding'>
            <CardNormal styles={{border:"none", boxShadow:"none", backgroundColor:"none"}}>
               <div align="center" style={{margin:"15px 0px", padding:"0px 10px"}}>
                  <div className='bold h2' style={{color:Colors.primary}}><b>Recovery OTP</b> </div>
                  <div className='regular h5' style={{color:Colors.gray, marginTop:"5px"}}>We sent an OTP to your email at mail@example.com. Enter the OTP below to continue</div>

                  <div style={{marginTop:"35px"}} align="left">
                     <Input
                        placeholder={"Enter OTP"} label="OTP" bg={Colors.bgShade1} type="number" limit={8}
                        value={otp.v} callback={(v)=>{otp.v=v; setOtp(JSON.parse(JSON.stringify(otp)))}}
                        hasError={otp.e} errorMessage={otp.m}
                      />
                  </div>
                   
                  <div style={{margin:"15px 0px", marginTop:"30px"}} align="left">
                     <PrimaryButton
                        label={"  Submit  "} busy={busy} callback={verify}
                      />
                  </div>
                   
               </div>
            </CardNormal>
         </div>
      </div>


      <div style={{minHeight:"5vh", backgroundColor:Colors.primary}}>
         
      </div>
   </div>
)
}
export default AdminPasswordRecoveryOTPView;